import { PRODUCT_ADJUSTABLE_BASE_2_ID } from 'gatsby-env-variables';
import React from 'react';
import { ProductFixedBottomBar } from '../common';

const AdjustableBaseProductFixedBottomBar: React.FC = () => {
  return <ProductFixedBottomBar productId={PRODUCT_ADJUSTABLE_BASE_2_ID} />;
};

export default AdjustableBaseProductFixedBottomBar;
